import { useQuery } from '@tanstack/react-query';

import { ITopUniversities } from '../models';
import { getTopUniversities } from '../queries';
import { universitiesConst } from '..';

export function useTopUniversitiesInfo() {
  const { data: topUniversities, ...args } = useQuery<ITopUniversities[]>({
    queryKey: [universitiesConst.queryKeys.TOP_UNIVERSITIES],
    queryFn: getTopUniversities
  });

  return { topUniversities, ...args };
}
